<template>
	<div>
		<headers></headers>
		<div class="flex center">
			<div class="problem-main mt-4">
				<img src="../../assets/image/textContent/problem.png" alt="" style="width: 100%;position: relative;" />
				<div class="flex column alcenter problem-main-head">
					<div class="text-center cl-w ftr-2 ftw600">
						{{$t('common.whatHelp')}}
					</div>
					<a-input style="width: 300px;" class="mt-2" :placeholder="$t('common.enter')"></a-input>
				</div>
				<div style="position: relative;">

					<div class="mt-3">
						<a-tabs v-model:activeKey="activeKey">
							<a-tab-pane key="1" :tab="$t('footers.Astudent')">
							</a-tab-pane>
							<a-tab-pane key="2" :tab="$t('footers.ATeacher')">
							</a-tab-pane>
							<a-tab-pane key="3" :tab="$t('common.generalQuestion')">
							</a-tab-pane>
						</a-tabs>
					</div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeKey: '1'
			}
		}
	}
</script>

<style>
	.problem-main {
		width: 80%;
		position: relative;
	}

	.problem-main-head {
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
		right: 0;
		padding-top: 5rem;
	}
	.ant-tabs-nav .ant-tabs-tab {
		font-size: 16px;
	}
	
	.ant-tabs-nav .ant-tabs-tab:hover {
		color: #52C4C9;
	}
	
	.ant-tabs-nav .ant-tabs-tab-active {
		color: #52C4C9;
		text-shadow: 0 0 0.25px #52C4C9
	}
	
	.ant-tabs-ink-bar {
		background-color: #52C4C9;
	}
</style>